import { ReportProfileAlertResourceBaseModel } from '../../../profile/report-profile-alert-resource-base-model';
import { SharePointReportProfileAlertDelegateModel } from '../../../microsoft/sharepoint/profile/share-point-report-profile-alert-delegate-model';

export class SharePointReportProfileAlertExternalDelegatesModel extends ReportProfileAlertResourceBaseModel {
  delegates: SharePointReportProfileAlertDelegateModel[];
}
